<template>
  <v-card class="overlayBanner" flat v-if="loading">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </v-card>
</template>

<script>
export default {
  name: "loadingComponent",

  props: ["loading"],
};
</script>
